// @ts-nocheck
import { useState, useEffect } from 'react';
import { Button, Paper, InputBase, IconButton, Tabs, Tab } from '@mui/material';
import { IconExport, IconSearch } from '../../../../icons/Icon';
import styles from './QuantitiesVarianceReportDetails.module.scss';
import CustomTabPanel from '../../../../components/commonComponent/CustomTabPanel';
import ListData from './ListData';
import { useSelector } from 'react-redux';
import Loader from '../../../../components/loader/Loader';
import * as XLSX from 'xlsx-js-style'
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { headerStyle, daypartStyle, titleStyle } from '../../../../utils/constants';

const QuantitiesVarianceReportDetails: React.FC<{ params: any }> = ({ params }) => {
  const [openIndices, setOpenIndices] = useState<number[]>([0]);  // Initially open the first accordion
  const [value, setValue] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [searchTerm, setSearchTerm] = useState<string | null>(null);
  const { menuReportDetails, loading } = useSelector((state: any) => state.varianceReport);
  const [filteredData, setFilteredData] = useState(menuReportDetails);

  useEffect(() => {
    if (searchTerm) {
      // Filter the data based on the search term
      const filteredData = menuReportDetails?.map((type: any) => ({
        ...type,
        daypartlist: type.daypartlist.map((daypart: any) => ({
          ...daypart,
          dishlist: daypart.dishlist.filter((dish: any) =>
            dish.dishname && dish.dishname.toLowerCase().includes(searchTerm.toLowerCase().trim()) // Filter by dishname
          ),
        })).filter((daypart: { dishlist: string | any[]; }) => daypart.dishlist.length > 0)
      }))
      // Find all indices where a match was found
      const allIndices = filteredData?.flatMap((type: any) =>
        type.daypartlist
          .map((daypart: any, index: number) =>
            daypart.dishlist.length > 0 ? index : null
          )
          .filter((index: any) => index !== null) // Only keep indices where a match was found
      ) || [];
      setFilteredData(filteredData);
      setOpenIndices(allIndices);
    } else {
      setFilteredData(menuReportDetails); // Show all data if no search term
      setOpenIndices([0]);
    }
  }, [searchTerm, menuReportDetails]);


  // Handle tab change
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setActiveTab(newValue);
    setOpenIndices([0]);  // Reset to open the first accordion when switching tabs
  };

  // Handle toggle change
  const handleToggle = (index: number) => {
    setOpenIndices(prevIndices =>
      prevIndices.includes(index) ? prevIndices.filter(i => i !== index) : [index]
    );
  };

  // Expand all sections
  const handleExpandAll = () => {
    const allIndices = filteredData?.flatMap((type: any) =>
      type.daypartlist.map((_: any, index: number) => index)
    ) || [];
    setOpenIndices(allIndices);
  };

  // Collapse all sections
  const handleCollapseAll = () => {
    setOpenIndices([]); // 
  };

  // Handle search submit
  const handleSearchSubmit = (event: React.FormEvent) => {
    event.preventDefault(); // For now just logging the search term
  };

  const handleExport = async () => {
    try {
      if (menuReportDetails && menuReportDetails?.length > 0) {
        // Create a new workbook and worksheet
        const workbook = XLSX.utils.book_new();
        menuReportDetails?.map((menuReport) => {
          let startingIndex = 0;
          let rowIndexes = [{
            index: startingIndex,
            style: 'title'
          }]
          let exportData: any = [
            ...[[`Projected Quantities vs Requested Quantities Variance Report for ${params?.plandate && format(new Date(params?.plandate), 'dd MMM yyyy')}`, ...Array(7).fill('')]],
            ...[[]]
          ];
          startingIndex++;
          menuReport?.daypartlist?.map((daypart) => {
            exportData?.push([[daypart?.daypartname, ...Array(5).fill('')]])
            startingIndex++;
            rowIndexes.push({
              index: startingIndex,
              style: 'daypart'
            })
            exportData.push(['Dish Name', 'Dish UOM', 'Dish Variant Name', 'Required From', 'Projected Qty', 'Required From', 'Requested Qty', 'Variance %'])
            startingIndex++;
            rowIndexes.push({
              index: startingIndex,
              style: 'header'
            })
            daypart?.dishlist?.map((dish) => {
              exportData?.push([dish?.dishname, dish?.dishuom,
              `${dish?.dishvariantname} ${dish?.dishvariantuom} ${dish?.dishvariantuom === 'Pcs' && dish?.weightperpc !== 0 ? `@${dish?.weightperpc} gms` : ''}`,
              dish?.menuprojectionrequiredfrom,
              `${dish?.projectedqty} ${dish?.dishvariantuom === 'gms' ? "Kg" : dish?.dishvariantuom}`,
              dish?.menurequisitionrequiredfrom,
              `${dish?.requestedqty} ${dish?.dishvariantuom === 'gms' ? "Kg" : dish?.dishvariantuom}`,
              dish?.variance])
              startingIndex++;
            })
            exportData?.push([[]])
            startingIndex++;
          })
          const wids = [{ wpx: 200 }, { wpx: 120 }]
          const worksheet = XLSX.utils.aoa_to_sheet(exportData);
          worksheet['!cols'] = [wids[0], wids[1], wids[0], ...Array(5).fill(wids[1])];
          worksheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 2 } },
          ];
          rowIndexes?.forEach((rowIndex => {
            // Apply the header style to all header cells
            for (let colIndex = 0; colIndex < 8; colIndex++) {
              const cellAddress = XLSX.utils.encode_cell({ r: rowIndex?.index, c: colIndex });
              if (!worksheet[cellAddress]) {
                worksheet[cellAddress] = {};
              }
              switch (rowIndex?.style) {
                case 'title':
                  worksheet[cellAddress].s = titleStyle;
                  break;
                case 'header':
                  worksheet[cellAddress].s = headerStyle;
                  break;
                case 'daypart':
                  worksheet[cellAddress].s = daypartStyle;
                  break;
                default:
                  break;
              }
            }
          }))
          XLSX.utils.book_append_sheet(workbook, worksheet, menuReport?.sitename?.replace(/[^a-zA-Z0-9]/g, ' '));
        })
        XLSX.writeFile(workbook, `Projected_Quantities_vs_Requested_Quantities_Variance_Report-${params?.plandate && format(new Date(params?.plandate), 'dd MMM yyyy')}.xlsx`);
        toast("File downloaded successfully!", { type: "success" });
      } else {
        toast("No data is available", { type: "info" });
      }
    } catch (err) {
      console.log("Error:", err)
      toast("Some error has occured", { type: "error" });
    }
  }

  return (
    <div className="white-box mb-12">
      <div className="flex justify-content-between align-items-center title-button-wrapper mb-8">
        <div className="flex align-items-center">
          <Paper component="form" className={`search-input mr-12`} onSubmit={handleSearchSubmit}>
            <InputBase
              placeholder="Search Dish Variant"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
            />
            <IconButton type="submit" aria-label="search">
              <IconSearch />
            </IconButton>
          </Paper>
        </div>
        <div className="button-wrap flex align-items-center">
          <Button className="link-btn" disableRipple onClick={handleExpandAll}>
            Expand All
          </Button>
          <span className='divider'></span>
          <Button className='link-btn' disableRipple onClick={handleCollapseAll}>
            Collapse All
          </Button>
          <span className="divider"></span>
          <button onClick={() => handleExport()} className="cmenu-btn mr-4">
            <IconExport /> Export
          </button>
        </div>
      </div>

      <div className={`flex justify-content-between ${styles.tabbingDataWrap}`}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Tabs"
          className="tabs-wrapper"
        >
          {filteredData?.map((type: any, i: number) => (
            <Tab
              key={i}
              label={type?.sitealias ? `${type.sitealias} (${type?.sitecode})` : type?.sitename}
              id={`simple-tab-${i}`}
              aria-controls={`simple-tabpanel-${i}`}
              disableRipple
              className={`tab ${activeTab === i ? 'active' : ''}`}
            />
          ))}
        </Tabs>
      </div>
      <div className="inner-contant kitchen-dashboard">
        {filteredData?.length > 0 ? (
          filteredData?.map((data: any, i: number) => (
            <CustomTabPanel key={i} value={value} index={i}>
              <ListData
                openIndices={openIndices}
                handleToggle={handleToggle}
                data={data.daypartlist}
              />
            </CustomTabPanel>
          ))
        ) : (
          <div className='innrBox active'>
            <div className="noData">No data found</div>
          </div>
        )}
      </div>
      {loading && <Loader />}
    </div>
  );
};

export default QuantitiesVarianceReportDetails;
